export default __webpack_public_path__ + "static/media/advicegradissuegfx-04.5f3c3ff7.png";